import { useAtomValue } from 'jotai';

import { authedAtTimestampAtom } from '../../auth/state';
import { useAtomCallbackMemoized } from '../../hooks/useAtomCallbackMemoized';

export const useGetAuthedAtTimestamp = () => {
  const getAuthedAtTimestamp = useAtomCallbackMemoized((get) => get(authedAtTimestampAtom), []);
  const authedAtTimestamp = useAtomValue(authedAtTimestampAtom);

  return [authedAtTimestamp, getAuthedAtTimestamp];
};
